import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import ErrorIcon from 'react-icons/lib/md/cancel';

import containerWidth from '../../../shared/helpers/containerWidth';

import TopHeader from '../TopHeader/TopHeader';
import TopNavigation from '../TopNavigation/TopNavigation';

import './ErrorScreen.scss';

const ErrorScreen = ({ match, phone }) => (
  <div className="container-fluid error-page">
    <TopNavigation stepNumber={5} />
    <TopHeader />
    <div className="row">
      <div className={`${containerWidth} text-center`}>
        <div className="mb-3">
          <ErrorIcon className="error-page__icon" />
        </div>
        <h3 className="error-page__message">Oops there was an error!</h3>
        <h3 className="error-page__message">Your order was not created.</h3>
        <p className="mt-5">Please contact us for further information.</p>
        {phone && (
        <p>
          Phone number:
          {phone}
        </p>
        )}
        <div className="d-flex justify-content-center mt-5">
          <a
            href={`/${match?.params?.companyName}/`}
            className="btn btn-outline-success confirmation-page__success-outline"
          >
            Try again
          </a>
        </div>
      </div>
    </div>
  </div>
);

ErrorScreen.propTypes = {
// eslint-disable-next-line react/no-typos
  match: ReactRouterPropTypes.match.isRequired,
  phone: PropTypes.string,
};
ErrorScreen.defaultProps = {
  phone: null,
};

export default ErrorScreen;
